import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import { listDirectBookingsImage } from 'config/imageUrls';
import { ContentSection, DividerTemp } from './styles';

export const DirectBookingSite = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={7}>
            <Typography variant="h2" mb={2}>
              Your Own Direct Booking Website
            </Typography>
            <Typography mb={2}>
              Take control of who stays in your property by sending friends and repeat guests directly to your own
              direct booking website.
            </Typography>
            <Typography mb={2}>
              <strong>Keep Your Guests.</strong>
              <br />
              When guests review property listings on other websites, they are inundated with similar rental units that
              they may book instead. The direct booking website is only for your property.
            </Typography>
            <Typography>
              <strong>Market Your Own Brand.</strong>
              <br />
              Upload your own logo and promote the website on the Internet and social media. The alluraDirect brand is
              not mentioned and guests will come book directly with you.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={5}>
            <img src={listDirectBookingsImage} width="100%" className="add-image-shadow" />
          </Grid>
        </Grid>
      </ContentSection>

      <ContentSection>
        <DividerTemp />
      </ContentSection>
    </>
  );
};
